import { Trans, useLingui } from '@lingui/react/macro';
import { Modal } from 'antd';
import { userContext } from 'contexts/UserContext';
import { useSubscriptions } from 'hooks/useSubscriptions';
import { useToggle } from 'hooks/useToggle';
import { DateTime } from 'luxon';
import { useCallback, useContext, useMemo } from 'react';
import { useHistory } from 'react-router';
import { accountsService } from 'services';

const SHOW_UNTIL = DateTime.now().endOf('month').minus({ day: 5 });
const SHOW_FROM = SHOW_UNTIL.minus({ days: 10 });
const IS_NOT_EXPIRED =
  DateTime.now() <= SHOW_UNTIL && DateTime.now() >= SHOW_FROM;

export function LowBalanceNotification() {
  const { userId, user } = useContext(userContext);
  const { data: balance } = accountsService.useBalanceQuery(userId);
  const { totalAmount, subscriptionsCount } = useSubscriptions(userId);
  const [isOpen, toggleIsOpen] = useToggle(true);

  const { t } = useLingui();
  const isLowBalance =
    balance && balance.Balance < totalAmount && subscriptionsCount > 0;
  const history = useHistory();

  const isRuUser = useMemo(
    () => user.Groups.some((g) => g.Country === 'ru'),
    [user]
  );

  const handleOk = useCallback(() => {
    toggleIsOpen();
    history.push('/services#pay');
  }, [history, toggleIsOpen]);

  return (
    (<Modal
      open={isOpen && isLowBalance && IS_NOT_EXPIRED && !isRuUser}
      okText={t`Перейти к оплате`}
      cancelText={t`Оплачу позже`}
      onCancel={toggleIsOpen}
      onOk={handleOk}
    >
      <Trans>
        <h3>Уважаемые пользователи GSM мониторинга!</h3>
        <p>
          Что бы избежать возможных сложностей при оплате услуг GSM мониторинга
          в начале месяца, настоятельно рекомендуем сделать очередной платеж за
          GSM мониторинг не позднее 25го числа текущего месяца.
        </p>
        <p>
          Это позволит оперативно разобраться в проблеме, если она возникнет во
          время оплаты, и минимизировать время недоступности мониторинга для вас
        </p>
      </Trans>
    </Modal>)
  );
}
